import React from 'react';
import { withStyles, Theme } from '@material-ui/core/styles';
import { Tooltip as BaseTooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlineSharp';


const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
  },
}))(BaseTooltip);

export function Tooltip({title}: {title: string}) {
  return (
    <HtmlTooltip className='metricIcon' title={title} placement='top' arrow>
      <HelpIcon fontSize='small'/>
    </HtmlTooltip>
  );
}